import type { TFunction } from "i18next";

export function optionLabel(
  t: TFunction,
  prefix: string,
  value: string | number | null | undefined,
  fallback?: string,
): string {
  if (value == null || value === "") {
    return fallback ?? t("common.na");
  }
  return t(`${prefix}.${String(value)}`, { defaultValue: fallback ?? String(value) });
}

export function withI18nKeys<T extends { value: string | number; label: string }>(
  options: T[],
  prefix: string,
): Array<T & { i18nKey: string }> {
  return options.map((option) => ({
    ...option,
    i18nKey: `${prefix}.${String(option.value)}`,
  }));
}
